export default "__VITE_ASSET__DHp1ybhC__"